export class Image {
  base64: string;

  constructor(obj) {
    this.base64 = obj.base64;
  }
}
